import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const RedirectInformationBlock = styled.article`
  a:active {
    text-decoration: none !important;
  }

  a, button, p {
    font-size: 0.875rem;
    text-decoration: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
